/* sugar:assets/offer-pills.js@2.2.0 */
/*
 * Offer Pills — shortcuts that pick a tier of the Offer List / Offer Cards in the same buy box.
 *
 * A pill only recommends. On load the pill whose offer is selected lights up (none if no pill
 * points at it); a tap lights the pill and selects its offer through the offers controller
 * (root.sugarOffers.selectOffer); a tier the shopper picks by hand afterwards leaves the pills
 * where they were, and the next pill tap picks again. Clicks are delegated from the document,
 * so pills the editor re-renders need no setup of their own.
 */
(function () {
  if (window.SugarOfferPills) return;

  function offersRoot(host) {
    const scope = host.closest('.featured-product-info') || host.closest('.shopify-section') || document;
    return scope.querySelector('[data-sugar-offers]');
  }

  function offerAt(root, n) {
    if (!root || !(n > 0)) return null;
    return root.querySelectorAll('.offer')[n - 1] || null;
  }

  function light(host, pill) {
    host.querySelectorAll('[data-op-offer]').forEach((el) => {
      const on = el === pill;
      if (el.classList.contains('is-active') === on) return;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function select(root, offer) {
    const controller = root.sugarOffers;
    if (!controller) return false;
    controller.selectOffer(offer.dataset.blockId, parseInt(offer.dataset.quantity, 10) || 1);
    return true;
  }

  // The pill pointing at the offer selected right now, read from the offers' own markup (the
  // list marks its first tier while it parses, before its script runs).
  function sync(host) {
    const root = offersRoot(host);
    if (!root) return;
    const offers = Array.from(root.querySelectorAll('.offer'));
    const index = offers.findIndex((offer) => offer.classList.contains('is-selected')) + 1;
    const pill = index > 0 ? host.querySelector(`[data-op-offer="${index}"]`) : null;
    light(host, pill);
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-sugar-offer-pills]').forEach((host) => {
      if (host.dataset.opSynced) return;
      host.dataset.opSynced = 'true';
      sync(host);
    });
  }

  document.addEventListener('click', (e) => {
    const pill = e.target.closest?.('[data-op-offer]');
    const host = pill?.closest('[data-sugar-offer-pills]');
    if (!host) return;
    light(host, pill);
    const root = offersRoot(host);
    const offer = offerAt(root, parseInt(pill.dataset.opOffer, 10));
    if (!offer || offer.classList.contains('offer--tier-unavailable')) return;
    // Tapped before the offers script has booted: it picks the tier as soon as it is ready.
    if (!select(root, offer)) root.dataset.opPending = String(parseInt(pill.dataset.opOffer, 10));
  });

  document.addEventListener('offers:ready', (e) => {
    const root = e.detail?.root;
    if (!root) return;
    const pending = parseInt(root.dataset.opPending, 10);
    delete root.dataset.opPending;
    const offer = offerAt(root, pending);
    if (offer) {
      select(root, offer);
      return;
    }
    document.querySelectorAll('[data-sugar-offer-pills]').forEach((host) => {
      if (offersRoot(host) === root) sync(host);
    });
  });

  document.addEventListener('shopify:section:load', (e) => syncAll(e.target));

  window.SugarOfferPills = { sync, syncAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll());
  } else {
    syncAll();
  }
})();
